import { z } from "zod";

export const contactRequestsFilterSchema = z.object({
  first_name: z.any().optional(),
  last_name: z.any().optional(),
  dni: z.any().optional(),
  email: z.any().optional(),
  phone: z.any().optional(),
  status: z.array(z.any()).optional(),
});
